import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

/**
 * Responsible for storing and mutating API access token.
 */
@Injectable({
  providedIn: 'root'
})
export class TokenService {
  /**
   * Emits true when access token has been retrieved.
   */
  public tokenReady$ = new BehaviorSubject<boolean>(false);

  private token : string = '';

  getToken(): string {
    return this.token;
  }

  setToken(token: string): void {
    this.tokenReady$.next(token !== '');
    this.token = token;
  }
}
